<script lang="ts">
  import { createEventDispatcher, type ComponentType } from 'svelte';
  import Media from '../media/Media.svelte';

  export let label = 'label';
  export let selectable = true;
  export let clickable = false;
  export let selected = false;
  export let rounded = false;

  export let iconLeft: ComponentType = null;
  export let imageLeft: string = null;
  export let selectedIconLeft: ComponentType = null;

  export let iconRight: ComponentType = null;
  export let imageRight: string = null;
  export let selectedIconRight: ComponentType = null;

  export let sm = false;
  export let md = false;
  export let lg = false;

  export let green = false;
  export let red = false;
  export let highContrast = false;

  const dispatch = createEventDispatcher<{ select: unknown; deselect: unknown; click: unknown }>();
</script>

<div
  role="button"
  tabindex="0"
  class="max-w-min whitespace-nowrap outline-transparent outline select-none flex gap-x-1 items-center font-medium ease-out duration-200 transition-all outline-1 py-2 px-3 text-sm  {$$props.class}"
  class:mouse-pointer={!clickable}
  class:rounded-full={rounded}
  class:rounded-lg={!rounded}
  class:md
  class:lg
  class:sm
  class:selected
  class:green
  class:red
  class:highContrast
  class:gray={!green && !red}
  class:clickable
  on:click={() => {
    if (selectable) {
      selected = !selected;
      dispatch(selected ? 'select' : 'deselect');
    }

    dispatch('click');
  }}
  on:keydown
>
  <slot name="icon-left">
    {#if iconLeft || (selectable && selectedIconLeft)}
      <div class="w-5">
        {#if selected && selectedIconLeft}
          <svelte:component this={selectedIconLeft} />
        {:else}
          <svelte:component this={iconLeft} />
        {/if}
      </div>
    {:else if imageLeft}
      <div class="w-5">
        <Media
          controls={false}
          alt="Tag Icon"
          src={imageLeft}
          class="w-5 aspect-square object-cover rounded-full"
        />
      </div>
    {/if}
  </slot>

  <div class="flex-grow w-max font-switzer">
    <slot>
      {label}
    </slot>
  </div>

  <slot name="icon-right">
    {#if selected}
      {#if iconRight || (selectable && selectedIconRight)}
        <div class="w-5">
          {#if selected && selectedIconRight}
            <svelte:component this={selectedIconRight} />
          {:else}
            <svelte:component this={iconRight} />
          {/if}
        </div>
      {:else if imageRight}
        <div class="w-5">
          <Media
            controls={false}
            alt="Tag Icon"
            src={imageRight}
            class="w-5 aspect-square object-cover rounded-full mr-2"
          />
        </div>
      {/if}
    {/if}
  </slot>
</div>

<style type="postcss">
  .green {
    @apply bg-brand-green-10 border border-brand-green-10 text-brand-green;
  }

  .red {
    @apply bg-[#f9e2df] border border-[#f9eddf] text-[#9d240f];
  }

  .gray {
    @apply bg-blueish-grey-100 text-blueish-grey-700;
  }

  .selected.green {
    @apply outline-brand-green;
  }

  .selected.gray {
    @apply bg-blueish-grey-200 outline-blueish-grey-400;
  }

  .selected.gray.highContrast {
    @apply text-white bg-garden-grey-800 outline-transparent;
  }

  .clickable {
    @apply duration-200;
  }
  .clickable:active {
    @apply scale-90;
  }

  .sm {
    @apply px-[10px] py-1 text-xs;
  }
  .md {
    @apply px-3 py-2 text-sm;
  }

  .lg {
    @apply px-3 py-2 text-base;
  }
</style>
